import { createContext } from 'react';

const MetricViewContext = createContext('sale');

export default MetricViewContext;